import { render } from "./AQI.vue?vue&type=template&id=3100f76a"
import script from "./AQI.vue?vue&type=script&lang=js"
export * from "./AQI.vue?vue&type=script&lang=js"
script.render = render

export default script